import {TERRAIN_SEGMENTS_X,TERRAIN_SEGMENTS_Z} from './terrain-resolution.js';
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const samplers=new WeakMap();

// A static collision surface sampled once, not thousands of expensive watershed queries
// each frame. Rain then intersects its slanted path, rather than the vertical source column.
export function createRainSurface(terrain,nx=TERRAIN_SEGMENTS_X,nz=TERRAIN_SEGMENTS_Z){
 if(nx===TERRAIN_SEGMENTS_X&&nz===TERRAIN_SEGMENTS_Z&&samplers.has(terrain))return samplers.get(terrain);
 const heights=new Float32Array((nx+1)*(nz+1)),baseHeights=new Float32Array(heights.length),lakeMask=new Uint8Array(heights.length);
 for(let j=0;j<=nz;j++)for(let i=0;i<=nx;i++){
  const x=-6+i*12/nx,z=-4.5+j*9/nz,river=terrain.riverInfo(x,z);
  const k=j*(nx+1)+i,ground=terrain.heightAt(x,z);lakeMask[k]=Number(terrain.lakeDistance(x,z)<1.12&&ground<.245);baseHeights[k]=Math.max(ground,river.d<river.width*1.10?river.alt+.008:-Infinity);heights[k]=Math.max(baseHeights[k],lakeMask[k]?.20:-Infinity);
 }
 function heightAt(x,z,waterLevel=.20){
  const u=clamp((x+6)*nx/12,0,nx-.000001),v=clamp((z+4.5)*nz/9,0,nz-.000001),i=Math.floor(u),j=Math.floor(v),fx=u-i,fz=v-j,k=j*(nx+1)+i;
  const h=i=>Math.max(baseHeights[i],lakeMask[i]?waterLevel:-Infinity),a=h(k),b=h(k+1),c=h(k+nx+1),d=h(k+nx+2);
  return fx+fz<=1?a+(b-a)*fx+(c-a)*fz:d+(c-d)*(1-fx)+(b-d)*(1-fz);
 }
 function travelLimit(column,windX,windZ,waterLevel=.20){
  const dx=windX*.07,dz=windZ*.07;
  if(column.top<=heightAt(column.x,column.z,waterLevel))return .025;
  let lo=0,hi=column.top+.12;
  for(let k=0;k<10;k++){
   const travel=(lo+hi)*.5,x=clamp(column.x+dx*travel,-5.9,5.9),z=clamp(column.z+dz*travel,-4.4,4.4);
   if(column.top-travel>heightAt(x,z,waterLevel))lo=travel;else hi=travel;
  }
  return Math.max(.025,hi);
 }
 const result={heightAt,travelLimit,heights,baseHeights,lakeMask,nx,nz};if(nx===TERRAIN_SEGMENTS_X&&nz===TERRAIN_SEGMENTS_Z)samplers.set(terrain,result);return result;
}
